import React from "react";
import Text from "@/components/ui/text";
import Badge from "@/components/ui/badge";
import { useTranslation } from "react-i18next";

interface Props {
  illustration: React.ReactNode;
  title: string;
  description: string;
  dataTest: string;
}

const InTheMakingTab: React.FC<Props> = ({
  illustration,
  title,
  description,
  dataTest
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex items-center justify-center w-full h-full min-h-[600px]"
      data-test={dataTest}
    >
      <div className="flex flex-col md:flex-row items-center gap-10 max-w-[760px]">
        <div className="flex-shrink-0">{illustration}</div>
        <div className="flex flex-col gap-3 max-w-[320px]">
          <Badge
            text={t("contracts.detailedView.inTheMaking")}
            textVariant="smBody"
            className="px-3 py-1"
          />
          <Text variant="lgSubtitleH1">{title}</Text>
          <Text variant="bodySecondary" className="text-tertiary">
            {description}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default InTheMakingTab;
